// Jeff Upp site palette: Playfair Display (editorial headings) + Manrope (body/UI).
// Brand colors pair the onboarding teal/blue with the oxblood in Jeff's supplied logo.
const JEFF_LOGO_URL = 'https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/logos/jeff-logo.png?v=20260830-2';

export const SITE_CONFIG = {
  ASSISTANT: { ENABLED: true },
  SITE_ID: 'jeffupp.ca',
  LISTING_PREVIEWS_ENABLED: true,
  BASE_URL: 'jeffupp.com',
  INSIGHTS_MARKET_NAME: 'Inland Empire',
  ANALYTICS: {
    GA4_MEASUREMENT_ID: 'G-F0YFK1SSNE'
  },
  // Site-specific Amplify build webhook used after public content changes.
  AMPLIFY_WEBHOOK: 'https://webhooks.amplify.us-east-1.amazonaws.com/prod/webhooks?id=aabeb929-bb9e-4c77-ae96-e74880d3b8d2&token=3bNzBwuBMP23WhUGboQoqngMI4uV1W718JaQ7KleyU&operation=startbuild',
  SENDER_EMAIL_ENCRYPTION_KEY: 'ddc32d25f6877ce7692b7361fe9c3cfa75c8fedc8ddbfb6529a636b950fd11bf',
  STATE: 'CA',
  SEARCH_STATES: ['CA'],
  AGENT: {
    MLS_ID: 'C18166',
    OFFICE_KEYS: ['3288467'],
    NAME: 'Jeff Upp',
    BROKERAGE: 'RE/MAX Champions',
    ASSISTANT_NAME: "Jeff's Real Estate Assistant",
    OFFICE_CITY: 'Upland',
    EMAIL: 'Uppbeet@gmail.com',
    PHONE: '+1-909-519-1114',
    OFFICE_PHONE: '+1-909-949-0605',
    ZILLOW_PROFILE: 'https://www.zillow.com/profile/JLUpp',
    ZILLOW_REVIEW: 'https://www.zillow.com/reviews/write/?s=X1-ZUz7washzpjeh5_8clor',
    GOOGLE_REVIEW: '',
    FACEBOOK: 'https://www.facebook.com/ReMaxChampionsJeffUpp/',
    INSTAGRAM: 'https://www.instagram.com/jeff.upp.1/?hl=en',
    LINKEDIN: 'https://www.linkedin.com/in/jeff-upp-31442bb/',
    TIKTOK: 'https://www.tiktok.com/@uppbeet',
    YOUTUBE: 'https://www.youtube.com/@jeffupp3243',
    TWITTER: 'https://x.com/uppbeet',
    BROKERAGE_LICENSE: '01333814',
    LICENSE: '01058008',
    YEARS_EXPERIENCE: '36',
    SERVICE_AREAS: [
      'Upland', 'Claremont', 'Rancho Cucamonga', 'Ontario', 'Chino Hills',
      'Chino', 'Pomona', 'Montclair', 'Fontana', 'Eastvale', 'Rialto', 'Corona'
    ]
  },
  OFFICE: {
    STREET: '121 S Mountain Ave',
    CITY: 'Upland',
    STATE: 'CA',
    ZIP: '91786'
  },
  BRAND: {
    LOGO_URL: JEFF_LOGO_URL,
    PRIMARY: '#75b8a4',
    SECONDARY: '#89bfe1',
    LOGO_RED: '#6b0b12',
    INK: '#132c2a',
    PAPER: '#f7f4ee'
  },
  LANDING_PAGE: {
    HERO_IMAGE: '/jeff-upp-upland-hero.jpg',
    ICONS: {
      MOON: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-moon.png',
      SUN: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-sun.png',
      BLOGS: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-blogs.png',
      REVIEWS: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-reviews.png',
      SEARCH: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-globe.png',
      AGENT: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-agent.png',
      ACCOUNT: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-account.png',
      ADMIN: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/toggle-admin.png'
    },
    VIDEOS: {
      HERO_BACKGROUND: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/ca-landing-002.mp4',
      HOME_VALUE: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic-dining-001.mp4'
    },
    EDITORIAL_IMAGES: {
      AGENT_PRIMARY: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/ca-upp-002.jpeg',
      AGENT_SECONDARY: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/ca-upp-001.jpeg',
      HOME_VALUE_POSTER: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/generic-condo-interior-001.jpg'
    },
    AGENT_IMAGE: '/headshot.jpg',
    LOGO_IMAGE: JEFF_LOGO_URL,
    CITY_IMAGES: {
      UPLAND: '/areas/upland.jpg',
      CLAREMONT: '/areas/claremont.jpg',
      RANCHO_CUCAMONGA: '/areas/rancho-cucamonga.jpg',
      ONTARIO: '/areas/ontario.jpg',
      CHINO_HILLS: '/areas/chino-hills.jpg',
      CHINO: '/areas/chino.jpg',
      POMONA: '/areas/pomona.jpg',
      MONTCLAIR: '/areas/montclair.jpg',
      FONTANA: '/areas/fontana.jpg',
      EASTVALE: '/areas/eastvale.jpg',
      RIALTO: '/areas/rialto.jpg',
      CORONA: '/areas/corona.jpg'
    },
    FOOTER_LOGO: 'https://aw-business-marketing.s3.us-east-1.amazonaws.com/websitesbyaw-transparent.png'
  },
  MLS: {
    NAME: 'California Regional Multiple Listing Service, Inc. (CRMLS)',
    SHORT_NAME: 'CRMLS',
    LOGO_URL: '/crmls-logo.png',
    // Exact disclosure text currently published by RE/MAX Champions.
    DISCLAIMER: 'Any property information referenced on this website comes from the Internet Data Exchange (IDX) program of CRMLS. All data, including all measurements and calculations of area, is obtained from various sources and has not been, and will not be, verified by broker or MLS. All information should be independently reviewed and verified for accuracy. Properties may or may not be listed by the office/agent presenting the information.'
  }
};

export const mlsForState = () => SITE_CONFIG.MLS;
export const ALL_MLS = [SITE_CONFIG.MLS];

export const SEO_CONFIG = {
  AGENT_NAME: SITE_CONFIG.AGENT.NAME,
  AGENT_EMAIL: SITE_CONFIG.AGENT.EMAIL,
  AGENT_PHONE: SITE_CONFIG.AGENT.PHONE,
  STREET_ADDRESS: SITE_CONFIG.OFFICE.STREET,
  CITY: SITE_CONFIG.OFFICE.CITY,
  STATE: SITE_CONFIG.STATE,
  ZIP_CODE: SITE_CONFIG.OFFICE.ZIP,
  COUNTRY: 'US',
  LATITUDE: '34.0975',
  LONGITUDE: '-117.6484',
  DOMAIN: 'jeffupp.com',
  FACEBOOK_URL: SITE_CONFIG.AGENT.FACEBOOK,
  INSTAGRAM_URL: SITE_CONFIG.AGENT.INSTAGRAM,
  TIKTOK_URL: SITE_CONFIG.AGENT.TIKTOK,
  YOUTUBE_URL: SITE_CONFIG.AGENT.YOUTUBE,
  TWITTER_HANDLE: SITE_CONFIG.AGENT.TWITTER,
  LINKEDIN_URL: SITE_CONFIG.AGENT.LINKEDIN,
  OG_IMAGE: 'https://jeffupp.com/headshot.jpg',
  TWITTER_IMAGE: 'https://jeffupp.com/headshot.jpg',
  LOGO_URL: SITE_CONFIG.BRAND.LOGO_URL
};
